import { FieldsFactory } from '../../../Factory/FieldsFactory';
import { AlgorithmHeatmapInstrumentGroup } from './AlgorithmHeatmapInstrumentGroup';
export class AlgorithmHeatmapRtDataGroup extends AlgorithmHeatmapInstrumentGroup {
    constructor(pfixFieldSet) {
        super(FieldsFactory.ALGORITHM_HEATMAP_RT_GROUP, pfixFieldSet);
    }
}
